import { Button } from '@/components/ui/button';
import { Modal } from './modal';
import { DialogClose } from '@/components/ui/dialog';
import { Trash2 } from 'lucide-react';
import { LoadingSpinner } from '@/components/loading-spinner';

interface DeleteConfirmationModalProps {
  title: string;
  description: string;
  buttonLabel: string;
  isLoading?: boolean;
  isOpen: boolean;
  handleDelete: () => void;
  handleCancel: () => void;
}

export const DeleteConfirmationModal = ({
  handleDelete,
  title,
  description,
  handleCancel,
  buttonLabel,
  isLoading = false,
  isOpen = false,
}: DeleteConfirmationModalProps) => {
  const Footer = () => (
    <>
      <DialogClose asChild>
        <Button
          id='delete-modal-cancel'
          onClick={handleCancel}
          variant='outline'
        >
          Cancel
        </Button>
      </DialogClose>
      <Button
        id='delete-modal-confirm'
        onClick={handleDelete}
        disabled={isLoading}
      >
        {isLoading ? (
          <>
            <LoadingSpinner /> {buttonLabel}
          </>
        ) : (
          buttonLabel
        )}
      </Button>
    </>
  );

  const Title = () => (
    <div className='flex items-center gap-2'>
      <Trash2 />
      {title}
    </div>
  );

  return (
    <Modal
      isDialogOpen={isOpen}
      footer={<Footer />}
      title={<Title />}
      description={description}
      setIsDialogOpen={handleCancel}
    />
  );
};
